import { Link, useLocation } from 'react-router-dom';
import { Home, Users, BookOpen, BookAIcon, FileQuestionMark, CircleQuestionMarkIcon, FileTextIcon, FolderOpen, GraduationCap, ClipboardList, Calculator, UserCheck, Shield, Files, Globe } from 'lucide-react';

const Sidebar = ({ user }) => {
  const location = useLocation();

  // Define navigation items based on user role
  const adminNavItems = [
    { path: '/dashboard', label: 'Dashboard', icon: Home },
    { path: '/users', label: 'Users', icon: Users },
    // { path: '/admin-management', label: 'Admin Management', icon: Shield },  
    { path: '/courses', label: 'Program', icon: BookOpen },
    { path: '/topics', label: 'Topics', icon: FolderOpen },
    { path: '/lessons', label: 'Lessons', icon: BookAIcon },
    { path: '/quizzes', label: 'Question set', icon: CircleQuestionMarkIcon },
    { path: '/questions', label: 'Question Bank', icon: FileQuestionMark },
    { path: '/classes', label: 'Classes', icon: GraduationCap },
    { path: '/exams', label: 'Exams', icon: ClipboardList },
    { path: '/articles', label: 'Articles', icon: FileTextIcon },
    { path: '/files', label: 'Files', icon: Files },
    { path: '/webconfig', label: 'Website Config', icon: Globe },
    // { path: '/test', label: 'LaTeX Test', icon: Calculator }
  ];

  const instructorNavItems = [
    { path: '/instructor', label: 'My Classes', icon: UserCheck }
  ];

  // Choose navigation items based on user role
  const navItems = user?.role === 'instructor' ? instructorNavItems : adminNavItems;

  
  return (
    <div className="w-64 h-screen bg-sidebar text-sidebar-foreground fixed left-0 top-0 overflow-y-auto z-50 transition-transform duration-300">
      <div className="p-6 border-b border-white/10">
        <h2 className="text-2xl font-semibold text-center">ICER Admin</h2>
      </div>
      
      <nav className="py-4">
        <ul className="space-y-0">
          {navItems.map((item) => {
            const IconComponent = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link 
                  to={item.path}
                  className={`flex items-center px-6 py-4 transition-all duration-300 border-l-4 ${
                    isActive 
                      ? 'bg-sidebar-active text-sidebar-foreground border-l-accent' 
                      : 'text-sidebar-foreground/80 hover:text-sidebar-foreground hover:bg-white/10 border-l-transparent hover:border-l-white/30'
                  }`}
                >
                  <IconComponent className="w-6 h-6 mr-3" />
                  <span className="text-base font-medium">{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;